import { render, staticRenderFns } from "./MapTalent.vue?vue&type=template&id=2f5bdfac&scoped=true"
import script from "./MapTalent.vue?vue&type=script&lang=js"
export * from "./MapTalent.vue?vue&type=script&lang=js"
import style0 from "./MapTalent.vue?vue&type=style&index=0&id=2f5bdfac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bdfac",
  null
  
)

export default component.exports